




import Vue from 'vue';
import Slideshow from './components/Slideshow.vue';

// Interfaces for component typechecking!
interface AppData {

}

interface AppMethods {

}

interface AppProps {

}

export default Vue.extend<AppData, AppMethods, {}, AppProps>({
	name: 'app',
	components: {
		Slideshow
	}
})
